<template>
  <div class="hint_button" @mouseenter="show_hint()" @mouseleave="hide_hint()" @click="show_hint()">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="9" r="7.5" stroke="#222222" stroke-width="1.5"/>
      <path d="M7.5 6.75C7.5 5.92157 8.17157 5.25 9 5.25C9.82843 5.25 10.5 5.92157 10.5 6.75C10.5 7.04861 10.4127 7.32685 10.2623 7.56059C9.81405 8.25725 9 8.92157 9 9.75V10.125" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M8.994 12.75H9.00073" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div class="hint_content" v-show="showState">
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="21" viewBox="0 0 8 21" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M-4.37114e-07 10.5C-5.68248e-07 7.5 8 4.5001 8 0.5L8 20.5C8 16.5251 -3.0598e-07 13.5 -4.37114e-07 10.5Z" fill="#656565"/>
      </svg>
      <span>
        <slot name="hint-text"></slot>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name : "HintButton",
  props : {
    text : String
  },
  data() {
    return{
      showState : false,
    }
  },
  methods : {
    show_hint : function() {
      this.showState = true;
    },
    hide_hint : function() {
      this.showState = false;
    }
  }
}
</script>

<style scoped>
.hint_button {
  cursor: pointer;
  display: flex;
  position: relative;
}

.hint_button span {
  color: var(--White, #FFF);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.hint_content {
  border-radius: 8px;
  background: var(--Gray, #656565);
  padding: 7px 12px 8px 12px;
  position: absolute;
  width: max-content;
  left: 28px;
  top: -110%;
  z-index: 10;
}

.hint_content svg {
  position: absolute;
  left: -7px;
  top: 18px;
}

.hint_content svg path {
  stroke: var(--Gray, #656565);
}
</style>